"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _actions = require("@otpusk/apisearch-toolbox/dist/search/actions");
var _selectors = require("@otpusk/apisearch-toolbox/dist/search/selectors");
var _actions2 = require("@otpusk/apisearch-toolbox/dist/queries/actions");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _selectors4 = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var R = _interopRequireWildcard(require("ramda"));
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _v = _interopRequireDefault(require("uuid/v4"));
var _pluralTranslations = require("../../../../localization/pluralTranslations");
var _config = require("../../../../services/config");
var _constants = require("../../../Search/constants");
var _actions3 = require("../../../Search/store/actions");
var _selectors5 = require("../../../Search/store/selectors");
var _selectors6 = require("../../../Search/components/GeoTreeControl/store/selectors");
var _excluded = ["daysDuration", "nights", "queryID", "onClickByBar"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var updateFrom = function updateFrom(momentFrom, daysDuration) {
  return R.call(R.pipe(function (days) {
    return R.concat(R.map(function (day) {
      return momentFrom.clone().subtract(day, 'days');
    }, R.reverse(days)), R.prepend(momentFrom, R.map(function (day) {
      return momentFrom.clone().add(day, 'days');
    }, days)));
  }, R.find(function (mbNextMomentFrom) {
    return mbNextMomentFrom.startOf('day').diff((0, _moment.default)().startOf('day'), 'day') > 0;
  })), R.range(1, R.inc(daysDuration / 2)));
};
var isDateOutside = function isDateOutside(date) {
  return date.clone().startOf('day').diff((0, _moment.default)().startOf('day').add(1, 'days'), 'day') <= 0;
};
var withPriceChartProps = function withPriceChartProps(Component) {
  var WithPriceChartProps = function WithPriceChartProps(_ref) {
    var daysDuration = _ref.daysDuration,
      nights = _ref.nights,
      queryID = _ref.queryID,
      onClickByBar = _ref.onClickByBar,
      props = _objectWithoutProperties(_ref, _excluded);
    var query = (0, _reactRedux.useSelector)(function (state) {
      return queryID === _constants.MAIN_QUERY_ID ? (0, _selectors5.getCombinedMainQueries)(state) : (0, _selectors2.getQuery)(state, {
        queryID: queryID
      });
    });
    var chartQueryID = (0, _react.useMemo)(function () {
      return "".concat(queryID, "-chart-").concat((0, _v.default)());
    }, [queryID]);
    var chartQuery = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors2.getQuery)(state, {
        queryID: chartQueryID
      });
    });
    var chart = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getChart)(state, {
        queryID: chartQueryID
      });
    });
    var countrySelector = (0, _react.useMemo)(function () {
      return chartQuery ? R.partialRight((0, _selectors3.getCountry)(), [{
        countryID: chartQuery.get(_fn.QUERY_PARAMS.COUNTRY)
      }]) : R.F;
    }, [chartQuery]);
    var hotelSelectorByHub = (0, _react.useMemo)(function () {
      return chartQuery && chartQuery.get(_fn.QUERY_PARAMS.HOTELS).size === 1 ? R.partialRight((0, _selectors4.getHotel)(), [chartQuery.get(_fn.QUERY_PARAMS.HOTELS).first()]) : R.F;
    }, [chartQuery]);
    var hotelSelectorByGeo = (0, _react.useMemo)(function () {
      return chartQuery && chartQuery.get(_fn.QUERY_PARAMS.HOTELS).size === 1 ? R.partialRight((0, _selectors3.getHotelByCountry)(), [{
        countryID: chartQuery.get(_fn.QUERY_PARAMS.COUNTRY),
        hotelID: chartQuery.get(_fn.QUERY_PARAMS.HOTELS).first()
      }]) : R.F;
    }, [chartQuery]);
    var geoTreeSelector = (0, _react.useMemo)(function () {
      return chartQuery && chartQuery.get(_fn.QUERY_PARAMS.CITIES).size === 1 ? R.partialRight((0, _selectors6.getGeoTreeByID)(), [{
        id: chartQuery.get(_fn.QUERY_PARAMS.CITIES).first(),
        key: chartQuery.get(_fn.QUERY_PARAMS.COUNTRY)
      }]) : R.F;
    }, [chartQuery]);
    var city = (0, _reactRedux.useSelector)(geoTreeSelector);
    var country = (0, _reactRedux.useSelector)(countrySelector);
    var hotelByHub = (0, _reactRedux.useSelector)(hotelSelectorByHub);
    var hotelByGeo = (0, _reactRedux.useSelector)(hotelSelectorByGeo);
    var dispatch = (0, _reactRedux.useDispatch)();
    var _useTranslation = (0, _reactI18next.useTranslation)('RESULTS'),
      t = _useTranslation.t;
    var adultsAccusativeTranslation = (0, _pluralTranslations.usePluralAdultsAccusativeTranslation)();
    var kidsAccusativeTranslation = (0, _pluralTranslations.usePluralKidsAccusativeTranslation)();
    var handleMoveByChart = (0, _react.useCallback)(function (nextChartQuery) {
      return dispatch(_actions.searchActions.clearSearch(chartQueryID)), dispatch(_actions2.queriesActions.createQuery(chartQueryID, nextChartQuery)), dispatch(_actions.searchActions.getPriceChart(chartQueryID, daysDuration, '2.6'));
    }, [dispatch, chartQueryID, daysDuration]);
    var handleNextChart = (0, _react.useCallback)(function () {
      var nextTo = chartQuery.getIn([_fn.QUERY_PARAMS.DATES, 'to']).clone().add(1, 'days');
      var nextChartQuery = chartQuery.setIn([_fn.QUERY_PARAMS.DATES, 'from'], nextTo).setIn([_fn.QUERY_PARAMS.DATES, 'to'], nextTo.clone().add(daysDuration, 'days'));
      handleMoveByChart(nextChartQuery);
    }, [chartQuery, daysDuration, handleMoveByChart]);
    var handlePrevChart = (0, _react.useCallback)(function () {
      var mbNextFrom = chartQuery.getIn([_fn.QUERY_PARAMS.DATES, 'from']).clone().subtract(R.inc(daysDuration), 'days');
      var nextChartQuery = chartQuery.setIn([_fn.QUERY_PARAMS.DATES, 'from'], isDateOutside(mbNextFrom) ? (0, _moment.default)().startOf('day').add(1, 'days') : mbNextFrom).setIn([_fn.QUERY_PARAMS.DATES, 'to'], chartQuery.getIn([_fn.QUERY_PARAMS.DATES, 'from']).clone().subtract(1, 'days'));
      handleMoveByChart(nextChartQuery);
    }, [chartQuery, daysDuration, handleMoveByChart]);
    var handleClickByBar = (0, _react.useCallback)(function (momentDate) {
      return dispatch((0, _actions3.search)(queryID, query.setIn([_fn.QUERY_PARAMS.DATES, 'from'], momentDate).setIn([_fn.QUERY_PARAMS.DATES, 'to'], momentDate).update(_fn.QUERY_PARAMS.FOOD, function (foods) {
        return foods.map(function () {
          return false;
        });
      }).toJS()));
    }, [dispatch, query, queryID]);
    var isDisabledPrevHandler = (0, _react.useMemo)(function () {
      return chartQuery && isDateOutside(chartQuery.getIn([_fn.QUERY_PARAMS.DATES, 'from']));
    }, [chartQuery]);
    var title = (0, _react.useMemo)(function () {
      return chartQuery ? R.join(' ', R.filter(Boolean, [t('CHART_TITLE', {
        adults: "".concat(chartQuery.get(_fn.QUERY_PARAMS.ADULTS), " ").concat(adultsAccusativeTranslation(chartQuery.get(_fn.QUERY_PARAMS.ADULTS)))
      }), chartQuery.get(_fn.QUERY_PARAMS.CHILDREN).size && t('CHART_TITLE_PART_ABOUT_KIDS', {
        kidsCount: chartQuery.get(_fn.QUERY_PARAMS.CHILDREN).size,
        kidsWord: kidsAccusativeTranslation(chartQuery.get(_fn.QUERY_PARAMS.CHILDREN).size)
      }), t('CHART_TITLE_PART_ABOUT_SEARCH_DIRECTION', {
        directionName: R.prop('name', hotelByHub) || R.prop('name', hotelByGeo) || R.prop('name', city) || country.nameVn
      })])) : '';
    }, [adultsAccusativeTranslation, chartQuery, city, country, /* dont write country.field, will be critical error */
    hotelByGeo, hotelByHub, kidsAccusativeTranslation, t]);
    (0, _react.useEffect)(function () {
      var nextFrom = updateFrom(query.getIn([_fn.QUERY_PARAMS.DATES, 'from']), daysDuration);
      var nextChartQuery = query.setIn([_fn.QUERY_PARAMS.DATES, 'from'], nextFrom.clone()).setIn([_fn.QUERY_PARAMS.DATES, 'to'], nextFrom.clone().add(daysDuration, 'days')).updateIn([_fn.QUERY_PARAMS.DURATION, 'from'], function (prev) {
        return nights || prev;
      }).updateIn([_fn.QUERY_PARAMS.DURATION, 'to'], function (prev) {
        return nights || prev;
      });
      dispatch(_actions2.queriesActions.createQuery(chartQueryID, nextChartQuery));
      dispatch(_actions.searchActions.getPriceChart(chartQueryID, daysDuration, '2.6'));
      return function () {
        return dispatch(_actions2.queriesActions.removeQuery(chartQueryID)), dispatch(_actions.searchActions.clearSearch(chartQueryID));
      };
    }, [dispatch, daysDuration, nights, query, chartQueryID]);
    return /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
      chart: chart,
      title: title,
      onChangeNext: handleNextChart,
      onChangePrev: !isDisabledPrevHandler ? handlePrevChart : undefined,
      onClickBar: !(0, _config.isTouristMode)() ? onClickByBar || handleClickByBar : undefined
    }));
  };
  WithPriceChartProps.propTypes = {
    daysDuration: _propTypes.default.number.isRequired,
    nights: _propTypes.default.number,
    queryID: _propTypes.default.string.isRequired,
    onClickByBar: _propTypes.default.func
  };
  return (0, _react.memo)(WithPriceChartProps);
};
var _default = exports.default = withPriceChartProps;